<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>{{ idName }}</span>
        <el-button
          type="text"
          style="float: right; padding: 3px 9px"
          v-if="!disabled"
          @click="del()"
          v-allow="'actDel'"
          >删除</el-button
        >
        <el-button
          type="text"
          style="float: right; padding: 3px 0px"
          v-if="!disabled"
          @click="add()"
          v-allow="'actAdd'"
          >新增</el-button
        >
        <el-button
          type="text"
          style="float: right; padding: 3px 0px"
          v-if="!disabled"
          @click="edit()"
          v-allow="'actModify'"
          >编辑</el-button
        >
      </div>
      <edit-form ref="editForm" @updateDisabled="updateDisabled" />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../edit-form/index.vue'
export default {
  props: {
    // disabled: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  components: {
    EditForm,
  },
  data() {
    return { disabled: false, idName: '' }
  },
  methods: {
    edit() {
      this.$refs.editForm.openEdit()
    },
    add() {
      this.$refs.editForm.openAdd()
    },
    del() {
      this.$refs.editForm.openDel()
    },
    addTop() {
      this.$refs.editForm.openAddTop()
      this.disabled = true
      this.idName = '新增顶级分类'
    },
    updateDisabled() {
      this.disabled = false
      this.idName = '详细信息'
    },
  },
}
</script>
